import { useAppointment } from '@entities/appointment/api/useAppointment';
import { useOrder } from '@features/student/order/api/useOrder';
import { Loader } from '@shared/ui/loader/loader';
import { PostPayment } from '@widgets/payments/ui/post-payment/post-payment';
import { useParams } from 'react-router-dom'

export const PostPaymentPage = () => {
	const {appointmentId} = useParams()

	if(appointmentId.includes('appointment-')){
		return <WithAppointment {...{appointmentId}}/>
	}else {
		return <WithOrder {...{appointmentId}}/>
	}
}

const WithAppointment = ({appointmentId}) => {
	const { data: appointment, isLoading} = useAppointment(appointmentId?.split('-').pop())

  if (isLoading || !appointment) return <Loader/>;
	
	return <PostPayment appointment={appointment} isAppointment/>
}

const WithOrder = ({appointmentId}) => {
	const { data: order, isLoading} = useOrder(appointmentId)
	
	const appointment = order?.items[0]?.appointment

	if (isLoading) return <Loader/>;
	
	return <PostPayment appointment={appointment} order={order}/>
}